import { Union, Record } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { AuthPersona__get_Name, AuthPersona__get_Claims, HomeApi_HomeIndexResponse_$reflection, AuthPersona_$reflection } from "../Shopfoo.Shared/Remoting.js";
import { class_type, union_type, tuple_type, record_type, list_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { Shopfoo_Shared_Remoting_FullContext__FullContext_PrepareQueryWithTranslations_1505, Remote$1, ApiRequestArgs$2, Cmder__ofApiRequest_Z503C4AF9, Remote$1_$reflection } from "../Remoting.js";
import { Translations_$reflection } from "../Shopfoo.Domain.Types/Translations.js";
import { ApiError_$reflection } from "../Shopfoo.Shared/Errors.js";
import { FSharpResult$2 } from "../fable_modules/fable-library-js.4.24.0/Result.js";
import { Cmd_ofEffect } from "../fable_modules/Fable.Elmish.4.2.0/cmd.fs.js";
import { defaultArg } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { defaultOf } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { createElement } from "react";
import React from "react";
import { int32ToString, createObj } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { ofArray } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { React_useElmish_Z6C327F2E } from "../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../fable_modules/Fable.Elmish.4.2.0/program.fs.js";
import { Shopfoo_Client_Pages_Shared_Env_IFullContext__IFullContext_get_Translations } from "./Shared.js";
import { empty, indexed, collect, singleton, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { Helpers_combineClasses } from "../fable_modules/Feliz.DaisyUI.5.0.0/DaisyUI.fs.js";
import { icon as icon_2 } from "../Components/Icon.js";
import user_lock from "@iconify-icons/fa6-solid/user-lock";
import { TranslationPages_Login__get_Access, TranslationPages_Login__get_Feat, TranslationPages_Login__get_Persona, AppTranslations__get_Login, TranslationPages_Login__get_SelectPersona, AppTranslations__get_Home, TranslationPages_Home__get_Login } from "../Shopfoo.Shared/Translations.js";
import { React_withKeyAuto_2B31D457 } from "../UI.js";
import circle_info from "@iconify-icons/fa6-solid/circle-info";
import folder_open from "@iconify-icons/fa6-solid/folder-open";
import cart_shopping from "@iconify-icons/fa6-solid/cart-shopping";
import store from "@iconify-icons/fa6-solid/store";
import gear from "@iconify-icons/fa6-solid/gear";
import { tryFind } from "../fable_modules/fable-library-js.4.24.0/Map.js";
import { UserIcon } from "../Components/User.js";
import { Feat } from "../Shopfoo.Domain.Types/Security.js";

export class Model extends Record {
    constructor(Personas) {
        super();
        this.Personas = Personas;
    }
}

export function Model_$reflection() {
    return record_type("Shopfoo.Client.Pages.Login.Model", [], Model, () => [["Personas", Remote$1_$reflection(list_type(AuthPersona_$reflection()))]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["HomeDataFetched", "Login"];
    }
}

export function Msg_$reflection() {
    return union_type("Shopfoo.Client.Pages.Login.Msg", [], Msg, () => [[["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [tuple_type(HomeApi_HomeIndexResponse_$reflection(), Translations_$reflection()), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", tuple_type(HomeApi_HomeIndexResponse_$reflection(), Translations_$reflection())]], [["ErrorValue", ApiError_$reflection()]]])]], [["Item", AuthPersona_$reflection()]]]);
}

function Cmd_loadHomeData(cmder, request) {
    return Cmder__ofApiRequest_Z503C4AF9(cmder, new ApiRequestArgs$2((api) => api.Home.Index(request), (arg) => (new Msg(0, [new FSharpResult$2(1, [arg])])), (arg_1) => (new Msg(0, [new FSharpResult$2(0, [arg_1])]))));
}

function init(env) {
    let tupledArg, copyOfStruct;
    return [new Model(new Remote$1(1, [])), (tupledArg = Shopfoo_Shared_Remoting_FullContext__FullContext_PrepareQueryWithTranslations_1505((copyOfStruct = env, copyOfStruct.FullContext), undefined), Cmd_loadHomeData(tupledArg[0], tupledArg[1]))];
}

function update(env, msg, model) {
    if (msg.tag === 1) {
        return [model, Cmd_ofEffect((_arg_2) => {
            let copyOfStruct_2 = env;
            copyOfStruct_2.Login(msg.fields[0]);
        })];
    }
    else if (msg.fields[0].tag === 1) {
        return [new Model(new Remote$1(2, [msg.fields[0].fields[0]])), Cmd_ofEffect((_arg_1) => {
            let copyOfStruct_1 = env;
            copyOfStruct_1.FillTranslations(msg.fields[0].fields[0].Translations);
        })];
    }
    else {
        return [new Model(new Remote$1(3, [msg.fields[0].fields[0][0].Personas])), Cmd_ofEffect((_arg) => {
            let copyOfStruct = env;
            copyOfStruct.FillTranslations(msg.fields[0].fields[0][1]);
        })];
    }
}

class Users {
    constructor() {
    }
}

function Users_$reflection() {
    return class_type("Shopfoo.Client.Pages.Login.Users", undefined, Users);
}

function Users_th_Z7DB4D774(key, text, icon, className) {
    let elems_1, elems;
    const icon_1 = defaultArg(icon, defaultOf());
    return createElement("th", createObj(ofArray([["key", `users-${key}-th`], ["className", defaultArg(className, "")], (elems_1 = [createElement("div", createObj(ofArray([["key", `users-${key}-th-content`], ["className", "flex items-center justify-left"], (elems = [icon_1, createElement("span", {
        key: `users-${key}-text`,
        className: "ml-2",
        children: `${text}`,
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function Users_td_5C98F074(key, text, icon) {
    let elems_1, elems;
    return createElement("td", createObj(ofArray([["key", `users-${key}-td`], (elems_1 = [createElement("div", createObj(ofArray([["key", `users-${key}-td-content`], ["className", "flex items-center justify-left"], (elems = [defaultArg(icon, defaultOf()), createElement("span", {
        key: `users-${key}-text`,
        className: "ml-2",
        children: `${text}`,
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

export function LoginView(loginViewInputProps) {
    let elems_7;
    const env = loginViewInputProps.env;
    let patternInput;
    const init_1 = init(env);
    patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init_1, (msg, model) => update(env, msg, model), (_arg, _arg_1) => {
    }), undefined, []);
    const translations = Shopfoo_Client_Pages_Shared_Env_IFullContext__IFullContext_get_Translations(env);
    return createElement("section", createObj(ofArray([["key", "login-page"], (elems_7 = toList(delay(() => {
        let elems_6, elems, elems_5, elems_2, elems_1, elems_4;
        const matchValue = patternInput[0].Personas;
        switch (matchValue.tag) {
            case 1:
                return singleton(createElement("div", createObj(Helpers_combineClasses("skeleton", ofArray([["className", "h-32 w-full"], ["key", "login-skeleton"]])))));
            case 2:
                return singleton(createElement("div", createObj(Helpers_combineClasses("alert", ofArray([["className", "alert-error"], ["key", "load-error"], ["children", matchValue.fields[0].ErrorMessage]])))));
            case 3:
                return singleton(createElement("fieldset", createObj(Helpers_combineClasses("fieldset", ofArray([["key", "login-fieldset"], ["className", "bg-base-200 border border-base-300 rounded-box p-4"], (elems_6 = [createElement("legend", createObj(ofArray([["key", "login-legend"], ["className", "text-sm flex items-center"], (elems = [icon_2(user_lock), createElement("span", {
                    key: "login-legend-text",
                    className: "ml-2",
                    children: TranslationPages_Home__get_Login(AppTranslations__get_Home(translations)),
                })], ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement("label", createObj(Helpers_combineClasses("fieldset-label", ofArray([["key", "login-label"], ["children", TranslationPages_Login__get_SelectPersona(AppTranslations__get_Login(translations))]])))), createElement("table", createObj(Helpers_combineClasses("table", ofArray([["key", "users-table"], ["className", "table-pin-rows w-full"], (elems_5 = [createElement("thead", createObj(ofArray([["key", "users-table-thead"], (elems_2 = [React_withKeyAuto_2B31D457(createElement("tr", createObj(ofArray([["className", "bg-base-300"], (elems_1 = [Users_th_Z7DB4D774("num", " "), Users_th_Z7DB4D774("persona", TranslationPages_Login__get_Persona(AppTranslations__get_Login(translations)), undefined, "w-1/6"), Users_th_Z7DB4D774("feat-about", TranslationPages_Login__get_Feat(AppTranslations__get_Login(translations)).About, icon_2(circle_info), "w-1/6"), Users_th_Z7DB4D774("feat-catalog", TranslationPages_Login__get_Feat(AppTranslations__get_Login(translations)).Catalog, icon_2(folder_open), "w-1/6"), Users_th_Z7DB4D774("feat-sales", TranslationPages_Login__get_Feat(AppTranslations__get_Login(translations)).Sales, icon_2(cart_shopping), "w-1/6"), Users_th_Z7DB4D774("feat-warehouse", TranslationPages_Login__get_Feat(AppTranslations__get_Login(translations)).Warehouse, icon_2(store), "w-1/6"), Users_th_Z7DB4D774("feat-admin", TranslationPages_Login__get_Feat(AppTranslations__get_Login(translations)).Admin, icon_2(gear), "w-1/6")], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))))], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))), createElement("tbody", createObj(ofArray([["key", "users-table-tbody"], (elems_4 = toList(delay(() => collect((matchValue_1) => {
                    let elems_3;
                    const persona = matchValue_1[1];
                    const i = matchValue_1[0] | 0;
                    const accessTo = (feat) => {
                        const matchValue_2 = tryFind(feat, AuthPersona__get_Claims(persona));
                        if (matchValue_2 == null) {
                            return "";
                        }
                        else if (matchValue_2.tag === 0) {
                            return TranslationPages_Login__get_Access(AppTranslations__get_Login(translations)).View;
                        }
                        else {
                            return TranslationPages_Login__get_Access(AppTranslations__get_Login(translations)).Edit;
                        }
                    };
                    return singleton(createElement("tr", createObj(ofArray([["key", `users-tr-${i}`], ["className", "hover:bg-accent hover:fg-accent hover:cursor-pointer"], ["onClick", (_arg_2) => {
                        patternInput[1](new Msg(1, [persona]));
                    }], (elems_3 = [Users_td_5C98F074(`${i}-num`, int32ToString(i + 1)), Users_td_5C98F074(`${i}-user`, AuthPersona__get_Name(persona), UserIcon(AuthPersona__get_Name(persona))), Users_td_5C98F074(`${i}-feat-about`, accessTo(new Feat(0, []))), Users_td_5C98F074(`${i}-feat-catalog`, accessTo(new Feat(2, []))), Users_td_5C98F074(`${i}-feat-sales`, accessTo(new Feat(3, []))), Users_td_5C98F074(`${i}-feat-warehouse`, accessTo(new Feat(4, []))), Users_td_5C98F074(`${i}-feat-admin`, accessTo(new Feat(1, [])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])]))));
                }, indexed(matchValue.fields[0])))), ["children", reactApi.Children.toArray(Array.from(elems_4))])])))], ["children", reactApi.Children.toArray(Array.from(elems_5))])]))))], ["children", reactApi.Children.toArray(Array.from(elems_6))])])))));
            default: {
                return empty();
            }
        }
    })), ["children", reactApi.Children.toArray(Array.from(elems_7))])])));
}

